import {del, download, get, post, postJson, upload} from '../fetch/http.js';
import * as types from '../vuex/types';
import {put, URL_ARRAY} from "./http";
import qs from 'qs'

let config = {headers: {'Content-Type': 'application/json'}}
let multipart = {headers: {'Content-Type': 'multipart/form-data'}};

export default {
  // 去组卷
  createExerciseBasketPaper(params){
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.TEACH_PATH + '/exerciseBaskets/groupPaper',params,remarks);
  },
  // 绑定题库
  chooseBank(params){
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.TEACH_PATH + '/exerciseBaskets/chooseBank',params,remarks);
  },
  deleteExerBasketAll() { //删除试题篮数据
    return del(types.TEACH_PATH + '/exerciseBaskets/deleteAll');
  },
  deleteExerBasketMultiple(typeId,courseId) { //删除试题篮数据
    return del(types.TEACH_PATH + '/exerciseBaskets/deleteMultiple/' + typeId + '/'+courseId);
  },
  deleteExerBasket(id) { //删除试题篮数据
    return del(types.TEACH_PATH + '/exerciseBaskets/delete/' + id);
  },
  getExerciseBasketCount() {  //查询试题篮数量
    return get(types.TEACH_PATH + '/exerciseBaskets/getCount');
  },
  getExerciseBasketsList() {  //查询试题篮list
    return get(types.TEACH_PATH + '/exerciseBaskets/list');
  },
  getExerciseBankList(courseId) {  //查询试题库list
    return get(types.TEACH_PATH + '/exerciseBaskets/bankList/course/' + courseId);
  },
  //创建试题篮数据
  createExerciseBaskets(param) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.TEACH_PATH + '/exerciseBaskets/create', param, remarks);
  },
  //添加全部试题蓝
  createExerciseBasketsAll(param) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.TEACH_PATH + '/exerciseBaskets/createAll', param, remarks);
  },
  getPaperTypeList() {  //查询试题库list
    return get(types.TEACH_PATH + '/exerciseBaskets/paperTypeList');
  },
}



// WEBPACK FOOTER //
// ./src/fetch/http-exercises-basket.js